import { format } from "date-fns";

import { dateUtils } from "@whoosh/utilities";

export const getCurrentDateStringOrDefaultToToday = (
  dateString?: string | null
) => {
  const todaysDate = format(new Date(), "yyyy-MM-dd");
  return dateUtils.isDateStringValid(dateString)
    ? (dateString as string)
    : todaysDate;
};
